var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "owner" } }, [
    _c("div", { staticClass: "profile" }, [
      _vm.showType(_vm.owner.type)
        ? _c("p", { staticClass: "type" }, [
            _vm._v(_vm._s(_vm.showType(_vm.owner.type))),
          ])
        : _vm._e(),
      _c("h1", [
        _c("ruby", [
          _vm._v(_vm._s(_vm.owner.name)),
          _c("rt", [_vm._v(_vm._s(_vm.owner.name_kana))]),
        ]),
      ]),
      _c(
        "p",
        { staticClass: "status" },
        [
          _vm._v(_vm._s(_vm.$t("Owners.company.is_active")) + ":"),
          _c(
            "el-tag",
            {
              attrs: {
                type: _vm.makeStatusCss(_vm.owner.is_active),
                size: "small",
              },
            },
            [_vm._v(_vm._s(_vm.showStatus(_vm.owner.is_active)))]
          ),
        ],
        1
      ),
      _c("p", { staticClass: "notes" }, [_vm._v(_vm._s(_vm.owner.notes))]),
    ]),
    _c(
      "div",
      { staticClass: "basic" },
      [
        _c("h2", [_vm._v(_vm._s(_vm.$t("Owners.company.basic_info")))]),
        _c("p", { staticClass: "humanized_id" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Owners.company.humanized_id"))),
          ]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.owner.humanized_id)),
          ]),
        ]),
        _vm.owner.type == "normal" && _vm.owner.distributor != null
          ? [
              _c("p", { staticClass: "distributor_humanized_id" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("Owners.company.distributor"))),
                ]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.owner.distributor.name)),
                ]),
              ]),
            ]
          : _vm._e(),
        _c("p", { staticClass: "zip_code" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Owners.company.zip_code"))),
          ]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.owner.zip_code)),
          ]),
        ]),
        _c("p", { staticClass: "address" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Owners.company.address"))),
          ]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.owner.address)),
          ]),
        ]),
        _c("p", { staticClass: "currency" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Owners.company.currency_setting"))),
          ]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.owner.currency)),
          ]),
        ]),
        _c("p", { staticClass: "phone_number" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Owners.company.phone_number"))),
          ]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.owner.phone_number)),
          ]),
        ]),
        _c("p", { staticClass: "fax_number" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Owners.company.fax_number"))),
          ]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.owner.fax_number)),
          ]),
        ]),
        _c("p", { staticClass: "timezone_tzinfo_ident" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Owners.company.timezone"))),
          ]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.owner.timezone_tzinfo_ident)),
          ]),
        ]),
      ],
      2
    ),
    _c("div", { staticClass: "cuona" }, [
      _c("h2", [_vm._v(_vm._s(_vm.$t("Owners.company.cuona_info")))]),
      _c("p", { staticClass: "firmware" }, [
        _c("span", { staticClass: "label" }, [
          _vm._v(_vm._s(_vm.$t("Owners.company.cube_firmware"))),
        ]),
        _c("span", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.showFirmware(_vm.owner.firmware))),
        ]),
      ]),
      _c("p", { staticClass: "num_cube_devices" }, [
        _c("span", { staticClass: "label" }, [
          _vm._v(_vm._s(_vm.$t("Owners.company.cube_num"))),
        ]),
        _c("span", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.owner.num_cube_devices)),
        ]),
      ]),
      _c("p", { staticClass: "num_tag_devices" }, [
        _c("span", { staticClass: "label" }, [
          _vm._v(_vm._s(_vm.$t("Owners.company.tag_num"))),
        ]),
        _c("span", { staticClass: "value" }, [
          _vm._v(_vm._s(_vm.owner.num_tag_devices)),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "other" },
      [
        _c("h2", [_vm._v(_vm._s(_vm.$t("Owners.company.other_info")))]),
        _c("p", { staticClass: "sdk_token" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Owners.company.sdk_token"))),
          ]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.owner.sdk_token)),
          ]),
        ]),
        _c("p", { staticClass: "key_code" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Owners.company.key_code"))),
          ]),
          _c("span", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.owner.key_code)),
          ]),
        ]),
        _vm.user.company.type == "admin"
          ? [
              _c("p", { staticClass: "stripe_customer_id" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("Owners.company.stripe_payment"))),
                ]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(
                    _vm._s(_vm.showStripeEnabled(_vm.owner.stripe_customer_id))
                  ),
                ]),
              ]),
              _c("p", { staticClass: "device_password" }, [
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("Owners.company.device_password"))),
                ]),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.owner.device_password)),
                ]),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }